import { Component, OnInit } from '@angular/core';
import { MvdModalService } from '../../modal/mvd-modal.service';
import { ConnectionResponse, ConnectionService } from '../connection-service.service';
import { ConnectionMonitorModalComponent } from './connection-monitor-modal.component';

export enum ConnectionState {
    ConnectivityIssues,
    SiteIssues,
    DatabaseIssues,
    Connected
}

export enum IndicatorState {
    Disconnected,
    SiteIssues,
    DatabaseIssues,
    Poor,
    Fair,
    Good,
}

export interface ConnectionHistory {
    apiVersion: string;
    serverName: string;
    statusMessage: string;
    styleClass: string;
    timestamp: Date;
}

@Component({
    selector: 'connection-monitor',
    templateUrl: './connection-monitor.component.html',
})
export class ConnectionMonitorComponent implements OnInit {
    public currentStatus: IndicatorState = null;
    public statusMessage: string = null;
    public styleClass: string = null;
    private recordedApiVersion: string = null;
    private responseHistory: ConnectionHistory[] = [];
    private stateHistory: ConnectionState[] = [];

    constructor(private connectionService: ConnectionService, private modalService: MvdModalService) { }

    ngOnInit() {
        this.connectionService.monitor().subscribe(x => {
            this.updateStateHistory(x);
            this.updateStatus();
            this.updateResponseHistory(x);
        });
    }

    public openModal() {
        this.modalService.open(ConnectionMonitorModalComponent, this.responseHistory).afterClosed()
            .subscribe(() => this.modalService.closeAll());
    }

    private getCurrentStatus(): IndicatorState {
        var valueCount = this.stateHistory.length;
        var successCount = this.stateHistory.filter(x => x == ConnectionState.Connected).length;

        if (this.stateHistory[0] == ConnectionState.ConnectivityIssues) {
            return IndicatorState.Disconnected;
        } else if (this.stateHistory[0] == ConnectionState.DatabaseIssues) {
            return IndicatorState.DatabaseIssues;
        } else if (this.stateHistory[0] == ConnectionState.Connected) {
            return IndicatorState.Good;
        } else if (this.stateHistory[0] == ConnectionState.SiteIssues) {
            if (successCount == 0) {
                if (valueCount == 3) {
                    return IndicatorState.SiteIssues;
                } else {
                    return IndicatorState.Poor;
                }
            } else if (successCount == (valueCount - 1)) {
                return IndicatorState.Fair;
            } else if (successCount == (valueCount - 2)) {
                return IndicatorState.Poor;
            }
        }
    }

    private getStatusMessage(indicatorState: IndicatorState): string {
        var status = 'Connection Status: ';
        if (indicatorState == IndicatorState.DatabaseIssues) {
            status = status + 'Database Offline.';
        } else if (indicatorState == IndicatorState.SiteIssues) {
            status = status + 'API Offline.';
        } else if (indicatorState == IndicatorState.Disconnected) {
            status = status + 'Internet disconnected.';
        } else {
            status = status + IndicatorState[indicatorState];
        }

        return status;
    }

    private getStyleClass(indicatorState: IndicatorState): string {
        switch (indicatorState) {
            case IndicatorState.DatabaseIssues: {
                return 'heartbeat--database-issues';
            }
            case IndicatorState.SiteIssues: {
                return 'heartbeat--site-issues';
            }
            case IndicatorState.Disconnected: {
                return 'heartbeat--disconnected';
            }
            case IndicatorState.Poor: {
                return 'heartbeat--poor';
            }
            case IndicatorState.Fair: {
                return 'heartbeat--fair';
            }
            case IndicatorState.Good: {
                return 'heartbeat--good';
            }
            default: {
                return null;
            }
        }
    }

    private updateResponseHistory(x: ConnectionResponse) {
        if (x.ApiVersion) {
            this.recordedApiVersion = x.ApiVersion;
        }
        this.responseHistory.unshift({
            apiVersion: this.recordedApiVersion,
            serverName: x.ServerName || 'No Server',
            statusMessage: this.statusMessage,
            styleClass: this.styleClass,
            timestamp: new Date()
        });
        while (this.responseHistory.length > 10) {
            this.responseHistory.pop();
        }
    }

    private updateStateHistory(resp: ConnectionResponse) {
        if (!resp.Browser) {
            this.stateHistory.unshift(ConnectionState.ConnectivityIssues);
        } else if (!resp.InternalSite) {
            this.stateHistory.unshift(ConnectionState.SiteIssues);
        } else if (!resp.Database) {
            this.stateHistory.unshift(ConnectionState.DatabaseIssues);
        } else {
            this.stateHistory.unshift(ConnectionState.Connected);
        }

        while (this.stateHistory.length > 3) {
            this.stateHistory.pop();
        }
    }

    private updateStatus() {
        this.currentStatus = this.getCurrentStatus();
        this.statusMessage = this.getStatusMessage(this.currentStatus);
        this.styleClass = this.getStyleClass(this.currentStatus);
    }
}
